/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Filters from "../../components/Filters";
import PageHeader from "../../components/PageHeader";
import { ControlTable } from "../../components/Table";
import useForm from "../../hooks/useForm";
import { getParams } from "../../utils/params";
import { permissionCheck } from "../../utils/permission";
import CounselingDetail from "./CounselingDetail";
import CommentIcon from "../../assets/images/icon/comment-icon.svg";
import Icon from "../../components/Icon";
import { COUNSELING_SEARCH_OPTIONS, COUNSELING_CATEGORY_TYPES } from "../../constants/COUNSELING";
import { getCounselingList } from "../../apis/counseling/counseling";
import { COMPANY_TYPE } from "../../constants/COMPANY";
import Profile from "../../components/Profile";

import { toast } from "../../utils/toast";
import systemAlert from "../../utils/systemAlert";
import { deleteCounseling } from "../../apis/counseling/counseling";
import SendEmailForm from "../../components/Counseling/SendEmailForm";

const Counseling = () => {
  const { counselingType } = useParams();

  const history = useHistory();
  const { permissions, employee, company } = useSelector((store) => ({
    permissions: store.Profile.permissions,
    employee: store.Profile.employee,
    company: store.Profile.company,
  }));

  const [mode, setMode] = useState("create");

  const [targetPermission, setTargetPermission] = useState(null);
  const [notices,] = useState([]);
  const [fields, setFields] = useState([]);
  const [readType, setReadType] = useState("all");
  const [open, setOpen] = useState(false);
  const [mailParams, setMailParams] = useState({});

  const rowBtnConfig = {
    rowButtons: [
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert(`"${data.title}" 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "삭제",
                onClick: () => {
                  setIsLoading(true);
                  deleteCounseling(counselingType, data.idx)
                    .then(() => {
                      submit(form);
                      systemAlert("삭제 되었습니다.");
                    });
                }
              }
            ]
          });
        },
      },
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "수정",
        type: "edit",
        action: (data) => {
          setMode("modify");
          setDetailOpen(true);
          setSelectedCounseling(data);
        },
      },
    ],
  };

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCounseling, setSelectedCounseling] = useState(null);
  const [filters, setFilters] = useState([
    {
      title: "카테고리",
      type: "select",
      key: "searchCategory",
      options: {
        list: [{ label: "전체", value: "" }, ...COUNSELING_CATEGORY_TYPES],
      },
    },
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: COUNSELING_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
    },
    {
      title: "미확인 항목 보기",
      key: "readType",
      type: "radio",
      className: "margin-right-16",
      options: {
        list: [
          { label: "전체", value: "all" },
          { label: "세무사 미확인", value: "tax_read" },
          { label: "고객사 미확인", value: "care_read" },
        ],
      },
    },
  ]);



  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: "titleAndContent",
      searchText: "",
      readType: "all",
      page: 0,
      limit: 10,
      order: [
        {
          createdTime: "desc",
        },
      ]
    },
  );

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permissionKey = `${counselingType.toUpperCase()}_COUNSELING`;
      const permission = permissions.find(p => p.code === permissionKey);
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, permissionKey);
      }
    }
  }, [permissions]);

  useEffect(() => {
    setFilters([
      {
        title: "카테고리",
        type: "select",
        key: "searchCategory",
        options: {
          list: [{ label: "전체", value: "" }, ...COUNSELING_CATEGORY_TYPES],
        },
      },
      {
        title: "분류",
        type: "select",
        key: "searchType",
        options: {
          list: COUNSELING_SEARCH_OPTIONS,
        },
      },
      {
        title: "키워드 검색",
        type: "input",
        key: "searchText",
        placeholder: "검색어 입력",
      },
      ...(employee?.type > 1 && employee?.managerCompanyIdx !== employee?.companyIdx ? [
        {
          title: "미확인 항목 보기",
          key: "readType",
          type: "radio",
          className: "margin-right-16",
          options: {
            list: [
              { label: "전체", value: "all" },
              { label: "세무사 미확인", value: "tax_read" },
              { label: "고객사 미확인", value: "care_read" },
            ],
          },
        }
      ] : []),
    ]);

    setFields([{
      //key: "index",
      key: "count",
      width: "100px"
    },
    {
      title: "카테고리",
      className: "text-align-left",
      key: "category",
      onValue: (value) => {
        const item = COUNSELING_CATEGORY_TYPES.find((item) => Number(item.value) === Number(value));
        return isEmpty(item) ? "" : item.label;
      },
    },
    {
      title: "제목",
      className: "text-align-left",
      key: "title",
      onValue: (value, _, d) => {
        const isNew = (employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewEmployee));

        const isUpdate = ((employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewTime))
          || (d?.comments?.comments || []).find(f =>
            employee.employeeIdx === f.writerEmpIdx ? readType === "care_read" ? !f.isRead : false : !f.isRead
          ));

        return (
          <>
            {value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> :
              <span className={`${!isNew && !isUpdate ? "" : "font-bold"}`}>
                {value}
              </span>
            }

            {isNew ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">new</small>
              : isUpdate ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">edited</small> : <></>
            }
          </>
        );
      },
    },
    {
      title: "작성자",
      key: "writerEmployee",
      onValue: (data, fields, datas) => {
        return <Profile data={data} className={`${datas.isManagerWrite ? "font-bold" : ""}`} />;
      }
    },
    { title: "작성일시", key: "createdTime", type: "datetime" },
    {
      title: "읽은사람", key: "viewEmployee",
      onValue: (data, fields, datas) => {
        return data ? <Profile data={data} className={`${!datas.isManagerWrite ? "font-bold" : ""}`} /> : "-";
      }
    },
    { title: "읽은시간", key: "viewTime", type: "datetime" },
    {
      title: "",
      key: "comments",
      onValue: (value) => {
        return (
          !isEmpty(value) ? (
            <>
              <Icon src={CommentIcon} />
              <span className="ml-4 font-bold">{value.count}</span>
            </>
          ) : (<></>)
        );
      }
    }]);

  }, [employee, readType]);

  useEffect(() => {
    if (counselingType && targetPermission) {
      submit(form);
      setSubmit(submit);
    }
  }, [counselingType, targetPermission]);

  const submit = ({ writerEmployee, ..._params }) => {

    const params = {
      ..._params,
      ...!isEmpty(writerEmployee) && { writerEmployeeIdx: writerEmployee.map(e => e.idx) }
    };

    setReadType(params.readType);

    setTotal(0);
    setList([]);
    setIsLoading(true);
    getCounselingList(counselingType, getParams(params))
      .then((res) => {
        const { total, metadata, counselings, comment } = res.data;

        if (!isEmpty(counselings)) {
          setTotal(total);
          setList(counselings.map((post, index) => ({
            ...post,
            count: total - metadata.offset - index,
            comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
          })));
        }
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const headerButtons = [
    {
      label: "글쓰기",
      action: () => {
        setMode("create");
        setDetailOpen(true);
      },
    },
  ];
  const openDetail = (data, e) => {
    if (isEmpty(data.title)) {
      toast.info("삭제된 게시글 입니다.");
      return;
    }

    setMode("view");
    setDetailOpen(true);
    setSelectedCounseling(data);
  };

  const tableButtons = [
    {
      label: '메일 알람 보내기',
      color: "gray-line",
      action: () => {
        setMailParams({
          type: counselingType,
          companyIdx: company.companyIdx,
          email: company.taxEmail || '',
        });
        setOpen(true);
      },
      disabled: 2 > company?.type
    }
  ];

  return (
    !isEmpty(targetPermission) && <>
      <PageHeader title={`${COMPANY_TYPE.find(c => c.id === counselingType).label} 상담`} buttons={headerButtons} />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        rowBtn={rowBtnConfig}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        notices={notices}
        limit={limit}
        setLimit={setLimit}
        onSelect={openDetail}
        submit={handleSubmit}
        buttons={tableButtons}
        // isReaction={true}
      />
      <CounselingDetail
        counselingType={counselingType}
        permission={targetPermission}
        counseling={selectedCounseling}
        setCounseling={setSelectedCounseling}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        orgMode={mode}
      />

      <SendEmailForm
        open={open}
        setOpen={setOpen}
        params={mailParams}
      />
    </>
  );
};

export default Counseling;
